import { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import { api } from "../lib/api";
import { useAuth, hasPerm } from "../context/AuthContext";

/**
 * Indicateur visible en permanence dès que la boutique de travail est en mode
 * Test / École (voir backend/compliance_utils.py) : rappel explicite qu'aucune
 * des ventes/avoirs/sessions/clôtures créés tant que ce bandeau est affiché
 * n'affecte le registre fiscal réel, le stock réel, ni les statistiques
 * réelles de la boutique — isolation totale (demande n°1).
 */
export function TestModeBanner() {
  const { user } = useAuth();
  const [mode, setMode] = useState(null);

  useEffect(() => {
    if (!hasPerm(user, "caisse", "access")) return;
    let cancelled = false;
    api.get("/caisse/mode").then(({ data }) => {
      if (!cancelled) setMode(data);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [user]);

  if (!mode || mode.mode !== "test") return null;

  return (
    <div
      data-testid="test-mode-banner"
      className="w-full bg-amber-500 text-white text-xs sm:text-sm font-medium py-1.5 px-4 flex items-center justify-center gap-2"
    >
      <FlaskConical size={14} />
      MODE TEST / ÉCOLE ACTIF — aucune donnée n'est réelle : ventes, stock, cumuls et clôtures sont isolés de la production.
    </div>
  );
}
